import { el } from '../utils/dom.js';
import { TOOLS } from '../utils/constants.js';

/**
 * Right-click context menu on the map canvas.
 */
export class ContextMenu {
  constructor(state, compositor, commandHistory, toolManager) {
    this.state = state;
    this.compositor = compositor;
    this.commandHistory = commandHistory;
    this.toolManager = toolManager;
    this._menu = null;

    compositor.canvas.addEventListener('contextmenu', (e) => {
      e.preventDefault();
      this._show(e);
    });

    document.addEventListener('click', () => this._hide());
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this._hide(); });
  }

  _show(e) {
    this._hide();

    const pos = { x: e.clientX, y: e.clientY };
    const tile = this.compositor.screenToTile(
      e.clientX - this.compositor.canvas.getBoundingClientRect().left,
      e.clientY - this.compositor.canvas.getBoundingClientRect().top
    );

    const hasSelection = this.state.get('selectionStart') && this.state.get('selectionEnd');
    const hasClipboard = !!this.state.get('clipboard');
    const selectTool = this.toolManager.getTool(TOOLS.SELECT);

    const items = [
      { label: `Tile: ${tile.x}, ${tile.y}`, disabled: true },
      { separator: true },
      { label: 'Pencil', shortcut: 'B', action: () => this.state.set('activeTool', TOOLS.PENCIL) },
      { label: 'Rectangle', shortcut: 'R', action: () => this.state.set('activeTool', TOOLS.RECT) },
      { label: 'Fill', shortcut: 'G', action: () => this.state.set('activeTool', TOOLS.FILL) },
      { label: 'Eraser', shortcut: 'E', action: () => this.state.set('activeTool', TOOLS.ERASER) },
      { separator: true },
      { label: 'Copy', shortcut: 'Ctrl+C', disabled: !hasSelection, action: () => { if (selectTool) selectTool.copySelection(); } },
      { label: 'Paste', shortcut: 'Ctrl+V', disabled: !hasClipboard, action: () => { if (selectTool) { this.state.set('activeTool', TOOLS.SELECT); selectTool.startPaste(); } } },
      { label: 'Delete', shortcut: 'Del', disabled: !hasSelection, action: () => { if (selectTool) { selectTool.deleteSelection(); this.compositor.requestRender(); } } },
      { separator: true },
      { label: 'Undo', shortcut: 'Ctrl+Z', disabled: !this.commandHistory.canUndo(), action: () => { this.commandHistory.undo(); this.compositor.requestRender(); } },
      { label: 'Redo', shortcut: 'Ctrl+Y', disabled: !this.commandHistory.canRedo(), action: () => { this.commandHistory.redo(); this.compositor.requestRender(); } },
    ];

    const menu = el('div', { className: 'context-menu' });

    for (const item of items) {
      if (item.separator) {
        menu.appendChild(el('div', { className: 'menu-separator' }));
        continue;
      }
      const row = el('div', {
        className: `menu-dropdown-item${item.disabled ? ' disabled' : ''}`,
      });
      row.appendChild(el('span', {}, item.label));
      if (item.shortcut) {
        row.appendChild(el('span', { className: 'menu-shortcut' }, item.shortcut));
      }
      if (!item.disabled && item.action) {
        row.addEventListener('click', (e) => {
          e.stopPropagation();
          this._hide();
          item.action();
        });
      }
      menu.appendChild(row);
    }

    // Position
    menu.style.left = `${pos.x}px`;
    menu.style.top = `${pos.y}px`;

    // Ensure menu stays on screen
    document.body.appendChild(menu);
    const rect = menu.getBoundingClientRect();
    if (rect.right > window.innerWidth) menu.style.left = `${pos.x - rect.width}px`;
    if (rect.bottom > window.innerHeight) menu.style.top = `${pos.y - rect.height}px`;

    this._menu = menu;
  }

  _hide() {
    if (this._menu) {
      this._menu.remove();
      this._menu = null;
    }
  }
}
